import React from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import Home from './components/pages/Home';
// import { Navbar } from './components';

import './App.css';
import SitePrivacyPolicy from './components/pages/SitePrivacyPolicy';
import Caravan from './components/pages/events/Caravan.js';
import EventsTop from './components/pages/events/EventsTop';
import Festa from './components/pages/events/Festa';
import Labyrinth from './components/pages/events/Labyrinth';
import Loulette from './components/pages/events/Loulette';
import Ranking from './components/pages/events/Ranking';
import Tp from './components/pages/events/Tp';
import Treasure from './components/pages/events/Treasure';

function App() {
  return (
    <Router basename="/app/">
      {/* <Router> */}
      <div className="App">
        {/* <Navbar /> */}
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/privacy" element={<SitePrivacyPolicy />} />
          <Route path="/events" element={<EventsTop />} />
          <Route path="events/caravan" element={<Caravan />} />
          <Route path="events/festa" element={<Festa />} />
          <Route path="events/treasure" element={<Treasure />} />
          <Route path="events/roulette" element={<Loulette />} />
          <Route path="events/rabyrinth" element={<Labyrinth />} />
          <Route path="events/tp" element={<Tp />} />
          <Route path="events/ranking" element={<Ranking />} />
          {/* <Route path="/test" element={<Test />} /> */}
        </Routes>
      </div>
    </Router>
  );
}

export default App;
